"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccumulateTxID = void 0;
const buffer_1 = require("../common/buffer");
const url_1 = require("./url");
class AccumulateTxID {
    constructor(input, hash) {
        if (hash) {
            if (typeof hash === "string") {
                hash = Uint8Array.from(buffer_1.Buffer.from(hash, "hex"));
            }
            if (!(input instanceof url_1.AccumulateURL)) {
                input = new url_1.AccumulateURL(input);
            }
            if (input.username) {
                throw new Error("Username is not empty");
            }
            this.hash = hash;
            this.account = input;
            return;
        }
        if (!(input instanceof url_1.AccumulateURL)) {
            input = new url_1.AccumulateURL(input);
        }
        if (!input.username) {
            throw new Error("URL is not a transaction ID: username is empty");
        }
        this.hash = buffer_1.Buffer.from(input.username, "hex");
        this.account = new url_1.AccumulateURL(input.toString({ omitUser: true }));
    }
    static parse(input) {
        if (input instanceof AccumulateTxID)
            return input;
        return new this(input);
    }
    asUrl() {
        const copy = (0, url_1.parseURL)(this.account.toString());
        copy.username = buffer_1.Buffer.from(this.hash).toString("hex");
        return new url_1.AccumulateURL(copy);
    }
    toString() {
        return this.asUrl().toString();
    }
    equals(u) {
        u = AccumulateTxID.parse(u);
        return this.toString().toLowerCase() === u.toString().toLowerCase();
    }
}
exports.AccumulateTxID = AccumulateTxID;
//# sourceMappingURL=txid.js.map